import { useNotificationStore } from '@/store/modules/notificationStore';
import VueI18n from 'vue-i18n';
import LocaleMessage = VueI18n.LocaleMessage;
import { NotificationObj, NotificationTypes } from '@cnamts/vue-dot/src/modules/notification/types';

const notificationManager = {
	displayMessage(type: string, message: string | LocaleMessage, timeout = 3000): void {
		timeout = 'error' === type && 3000 === timeout ? 4000 : timeout;

		const notificationType = type as NotificationTypes;
		const finalMessage = message?.toString();
		const notification: NotificationObj = {
			type: notificationType,
			message: finalMessage
		};

		this.add(notification);

		setTimeout(() => {
			this.clearNotification();
		}, timeout);
	},

	add(notification: NotificationObj) {
		return this.getUseNotificationStore().add(notification);
	},
	clearNotification() {
		return this.getUseNotificationStore().clearNotification;
	},
	getUseNotificationStore() {
		return useNotificationStore();
	}
};

export default notificationManager;
